// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-evaluation--icon-close[data-v-5173fb7d] {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.add-evaluation--icon-close[data-v-5173fb7d]:hover {\n  background-color: rgba(62, 62, 60, 0.1);\n}", ""]);
// Exports
module.exports = exports;
